import { PublicModulesRouteMap } from '@/new-router/public-modules'

const packMachineDetail = () => import('@/views/Pack/packMachineDetail')
const packProjectDetail = () => import('@/views/Pack/packProjectDetail')
const packRentDetail = () => import('@/views/Pack/packRentDetail')

const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
  nocache: true                  组件将不keep-alive
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
  }
**/

export default [
  {
    path: '/pack',
    name: 'pack',
    component: Home,
    meta: {
      title: '包机包项目明细',
      icon: 'icon-rent',
      showSubiems: false,
      sort: 5,
      modules: 'pack',
      permission: 'pack:root',
    },
    children: [
      {
        path: 'packMachineDetail',
        name: 'packMachineDetail',
        component: packMachineDetail,
        meta: {
          title: '包机明细',
          active: ['packMachineDetail'],
          permission: 'pack:node',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.PackManagement],
        },
      }, {
        path: 'packProjectDetail',
        name: 'packProjectDetail',
        component: packProjectDetail,
        meta: {
          title: '包项目明细',
          active: ['packProjectDetail'],
          permission: 'pack:project',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.PackManagement],
        },
      }, {
        path: 'packRentDetail',
        name: 'packRentDetail',
        component: packRentDetail,
        meta: {
          title: '节点机租赁明细',
          active: ['packRentDetail'],
          permission: 'rent:node',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.PackManagement],
        },
      },
    ],
  },
]
